import { render, staticRenderFns } from "./GreenButton.vue?vue&type=template&id=ba6c33ec&scoped=true&"
import script from "./GreenButton.vue?vue&type=script&lang=js&"
export * from "./GreenButton.vue?vue&type=script&lang=js&"
import style0 from "./GreenButton.vue?vue&type=style&index=0&id=ba6c33ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6c33ec",
  null
  
)

export default component.exports